'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _cookiesJs = require('cookies-js');

var _cookiesJs2 = _interopRequireDefault(_cookiesJs);

var _DeviceInfo = require('./DeviceInfo');

var _DeviceInfo2 = _interopRequireDefault(_DeviceInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var parseCookie = function parseCookie() {
    var ret = new _DeviceInfo2.default();
    try {
        var deviceCookie = _cookiesJs2.default.get('wh_device');
        if (typeof deviceCookie === 'string') {
            ret.setup(JSON.parse(deviceCookie));
        }
    } catch (e) {
        console.log('DeviceInfo: ', e);
    }
    return ret;
};

var savedDeviceInfo = null;

var getDeviceInfo = function getDeviceInfo() {
    if (savedDeviceInfo === null) {
        savedDeviceInfo = parseCookie();
    }
    return savedDeviceInfo;
};

exports.default = getDeviceInfo;
//# sourceMappingURL=deviceDetector.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/redux-device-detection/dist/main/deviceDetector.js
// module id = 517
// module chunks = 0